const MODULE_NAME = 'PASSWORD_RESET';
const PASSWORD_RESET_SUBMIT = MODULE_NAME + 'SUBMIT';
const PASSWORD_RESET_COMPLETED = MODULE_NAME + 'COMPLETED';
const PASSWORD_RESET_FAILED = MODULE_NAME + 'FAILED';
const PASSWORD_RESET_RESET = MODULE_NAME + 'RESET';

export {
  PASSWORD_RESET_SUBMIT,
  PASSWORD_RESET_COMPLETED,
  PASSWORD_RESET_FAILED,
  PASSWORD_RESET_RESET
};
